import React, { useMemo, useState } from 'react';
import { activePedagogicalAlerts, buildPedagogicalAlerts, dismissPedagogicalAlert, loadAlertDismissals } from '../../lib/pedagogical-alerts.js';

const SEVERITY_LABEL = { seguranca: 'Segurança', atencao: 'Atenção', revisao: 'Revisão' };

export function PedagogicalAlertsPanel({ students = [], assessments = [], logs = [], peis = [], professionalId = '' }) {
  const generated = useMemo(() => buildPedagogicalAlerts({ students, assessments, logs, peis }), [students, assessments, logs, peis]);
  const [dismissals, setDismissals] = useState(() => loadAlertDismissals());
  const [dismissingId, setDismissingId] = useState('');
  const [justification, setJustification] = useState('');
  const [message, setMessage] = useState('');
  const [showAll, setShowAll] = useState(false);
  const active = useMemo(() => activePedagogicalAlerts(generated, dismissals), [generated, dismissals]);
  const visible = showAll ? active : active.slice(0, 5);

  if (!active.length) return <section className="pedagogical-alerts pedagogical-alerts--clear"><strong>Cuidados pedagógicos</strong><span>Nenhum sinal pendente para revisão.</span></section>;

  const confirmDismissal = (alert) => {
    try {
      setDismissals(dismissPedagogicalAlert(alert, { justification, professionalId }));
      setDismissingId('');
      setJustification('');
      setMessage('Alerta dispensado. Ele reaparecerá se houver nova evidência.');
    } catch (error) { setMessage(error.message); }
  };

  return (
    <details className="pedagogical-alerts">
      <summary><span><strong>Cuidados pedagógicos</strong><small>{active.length} sinal(is) para revisar, sem bloquear o atendimento</small></span></summary>
      <div className="pedagogical-alerts__list">
        {visible.map((alert) => (
          <article className={`pedagogical-alert pedagogical-alert--${alert.severity}`} key={`${alert.id}:${alert.signature}`}>
            <header><span>{SEVERITY_LABEL[alert.severity]}</span><strong>{alert.studentName}</strong></header>
            <p><b>Por que apareceu:</b> {alert.cause}</p>
            <p><b>Ação sugerida:</b> {alert.action}</p>
            {dismissingId === alert.id ? (
              <div className="pedagogical-alert__dismiss">
                <label>Justificativa curta<input autoFocus maxLength="180" value={justification} onChange={(event) => setJustification(event.target.value)} /></label>
                <button type="button" onClick={() => confirmDismissal(alert)}>Confirmar dispensa</button>
                <button type="button" onClick={() => { setDismissingId(''); setJustification(''); setMessage(''); }}>Cancelar</button>
              </div>
            ) : <button type="button" onClick={() => { setDismissingId(alert.id); setJustification(''); setMessage(''); }}>Dispensar</button>}
          </article>
        ))}
        {active.length > 5 ? <button className="pedagogical-alerts__more" type="button" onClick={() => setShowAll((value) => !value)}>{showAll ? 'Mostrar menos' : `Ver mais ${active.length - 5}`}</button> : null}
      </div>
      {message ? <p className="pedagogical-alerts__message" role="status">{message}</p> : null}
      <p className="hint">Alertas apoiam a revisão pedagógica; não geram diagnóstico e não impedem registrar o atendimento.</p>
    </details>
  );
}

export default PedagogicalAlertsPanel;
